import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout.component';
import { WPASSComponent } from '../system-level-setting/wpass/wpass.component';
import { AdminDashboardComponent } from '../admin-dashboard/admin-dashboard.component';
import { PartnersDashboardComponent } from '../partners-dashboard/partners-dashboard.component';
import { ApplicationsManagerDashboardComponent } from '../applications-manager-dashboard/applications-manager-dashboard.component';
import { ProfileComponent } from '../profile/profile.component';
import { userActivityLogs} from '../user-activity-logs/user-activity.logs.component';
import { TranslationMessagesComponent } from '../translation-messages/translation-messages.component'
import {TranslationEmailComponent} from '../translation-email/translation-email.component'
const routes: Routes = [
    {
        path: 'app',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: '/app/admin-dashboard', pathMatch: 'full' },
            { path: 'wpass', component: WPASSComponent },
            { path: 'admin-dashboard', component: AdminDashboardComponent },
            { path: 'translation-messages', component: TranslationMessagesComponent },
            { path: 'translation-email', component: TranslationEmailComponent },
            { path: 'user-activity-logs', component: userActivityLogs },
            { path: 'partners-dashboard', component: PartnersDashboardComponent },
            { path: 'partners-dashboard/:id', component: PartnersDashboardComponent },
            { path: 'application-manager-dashboard', component: ApplicationsManagerDashboardComponent },
            { path: 'profile', component: ProfileComponent },
            { path: 'user', loadChildren: '../user/user.module#UserModule' },
            { path: 'request-application', loadChildren: '../user-operations/request-business-unit/request-business-unit.module#RequestBusinessUnitModule' },
            { path: 'chart', loadChildren: '../charts/charts.module#ChartsModule' },
            { path: 'ecommerce', loadChildren: '../ecommerce/ecommerce.module#ECommerceModule' },
            { path: 'form', loadChildren: '../forms/forms.module#MyFormsModule' },
            { path: 'page', loadChildren: '../pages/pages.module#PagesModule' },
            { path: 'pglayout', loadChildren: '../page-layouts/page-layouts.module#PageLayoutsModule' },
            { path: 'table', loadChildren: '../tables/tables.module#MyTablesModule' },
            { path: 'ui', loadChildren: '../ui/ui.module#UIModule' },
            { path: 'file-upload', loadChildren: '../file-upload/fileUpload.module#CSVUploadModule' },
            { path: 'manage-admin', loadChildren: '../system-level-setting/adminManagement/adminManagement.module#AdminManagementModule' },
            { path: 'manage-business-unit', loadChildren: '../system-level-setting/businessUnitManagement/businessUnitManagement.module#BusinessUnitManagementModule' },
            { path: 'manager-assignment', loadChildren: '../system-level-setting/managerAssignment/managerAssignment.module#ManagerAssignmentModule' },
            { path: 'application-management', loadChildren: '../system-level-setting/applicationManagement/applicationManagement.module#ApplicationManagementModule' },
            { path: 'view-request', loadChildren: '../viewRequest/view-request.module#ViewRequestModule' },
        ]
    }
];

export const LayoutRoutingModule = RouterModule.forChild(routes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout-routing.module.ts